import React from 'react';

import { UL } from './listComponents-styled-component';

const List = props => {
  return <UL>{props.children}</UL>;
};

export default List;
